import styled from 'styled-components';
import { Button, PopoverBody, Popover } from 'reactstrap';

export const Wrapper = styled.div`
    text-align: center;
`;

export const IconButton = styled(Button)`
    margin: 5px;
    width: 39px;
    border-radius: none;
`;

export const PopoverContent = styled(PopoverBody)`
    overflow-y: auto;
`;

export const StyledPopover = styled(Popover)`
    .popover {
        background-color: #f9f7f6ff;
        border-radius: 28px;
        max-width: ${props => `${props.maxWidth}px`};
        z-index: 90;
        padding: 20px;
        box-shadow: 10px 20px 6px 0px #00000000, 6px 13px 6px 0px #00000005, 3px 7px 5px 0px #0000000f,
            2px 3px 4px 0px #0000001a, 0px 1px 2px 0px #0000001f;
    }
`;
